export default __webpack_public_path__ + "static/media/sample_2.22f1f1f8.png";